var map = {
	"./Air pollution.svg": [
		4124,
		1,
		4124
	],
	"./AirPollution": [
		84531,
		9,
		4531
	],
	"./AirPollution.js": [
		84531,
		9,
		4531
	],
	"./Coastal": [
		60980,
		9,
		980
	],
	"./Coastal erosion.svg": [
		64271,
		1,
		4271
	],
	"./Coastal.js": [
		60980,
		9,
		980
	],
	"./Coastal.svg": [
		22069,
		1,
		2069
	],
	"./CoastalErosion": [
		15928,
		9,
		5928
	],
	"./CoastalErosion.js": [
		15928,
		9,
		5928
	],
	"./Drought": [
		34625,
		9,
		4625
	],
	"./Drought.js": [
		34625,
		9,
		4625
	],
	"./Drought.svg": [
		53119,
		1,
		3119
	],
	"./Extreme storms.svg": [
		78717,
		1,
		8717
	],
	"./ExtremeStorms": [
		77093,
		9,
		7093
	],
	"./ExtremeStorms.js": [
		77093,
		9,
		7093
	],
	"./Flood": [
		48205,
		9,
		8205
	],
	"./Flood.js": [
		48205,
		9,
		8205
	],
	"./Flood.svg": [
		99528,
		1,
		9528
	],
	"./Sea level rise.svg": [
		42162,
		1,
		2162
	],
	"./SeaLevelRise": [
		63495,
		9,
		3495
	],
	"./SeaLevelRise.js": [
		63495,
		9,
		3495
	],
	"./Temperature": [
		92057,
		9,
		2057
	],
	"./Temperature.js": [
		92057,
		9,
		2057
	],
	"./Temperature.svg": [
		79296,
		1,
		9296
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[2]).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 66597;
module.exports = webpackAsyncContext;